module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-medical-fill-fcd53fde.svg";